import React from 'react'

import { ParagraphLg } from 'components/display/Typography'
import ButtonLink from 'components/display/ButtonLink'
import SimpleAnchor from 'components/display/SimpleAnchor'
import { SectionSubtitle } from 'pages/static/section'
import { HeaderCentered, ButtonWrapper, SupportTextWrapper } from '../styles'

const JoinUs = () => {
  return (
    <>
      <HeaderCentered>
        <SectionSubtitle>Ready to join Riparide?</SectionSubtitle>
        <ParagraphLg>
          Create your listing today and welcome your first guests.
        </ParagraphLg>
      </HeaderCentered>
      <ButtonWrapper>
        <ButtonLink href="/my/listings/new" inline>
          Get started
        </ButtonLink>
        <SupportTextWrapper>
          Need help signing up as a Host?{' '}
          <SimpleAnchor href="mailto:support@riparide.com">
            Contact our Support Team
          </SimpleAnchor>
        </SupportTextWrapper>
      </ButtonWrapper>
    </>
  )
}

export default JoinUs
